import DOMPurify from 'dompurify';
import React, {Fragment, memo, useMemo} from 'react';

import {
  getFCPathForTag,
  useGallerySpec,
  useReportTags,
} from '../../util/gallery';
import * as S from './ReportPage.styles';

type FullyConnectedReportTagsProps = {
  reportId: string;
};

const FullyConnectedReportTagsComp = ({
  reportId,
}: FullyConnectedReportTagsProps) => {
  const {
    gallerySpec: {tagsV2},
  } = useGallerySpec();

  const {tags, primaryTag} = useReportTags(reportId, true);
  const hasReportTags = tags.length > 0;

  const primaryCTA = useMemo(() => {
    if (primaryTag?.cta != null) {
      return primaryTag.cta;
    }
    const articlesTag = tagsV2.find(t => t.name === `Articles`);
    return articlesTag?.cta;
  }, [primaryTag, tagsV2]);

  return (
    <>
      {hasReportTags && (
        <S.FCReportTags>
          Tags:{' '}
          {tags.map((t, i) => (
            <Fragment key={t.id}>
              {i > 0 && `, `}
              <S.FCReportTag to={getFCPathForTag(t)}>{t.name}</S.FCReportTag>
            </Fragment>
          ))}
        </S.FCReportTags>
      )}
      {primaryCTA && (
        <S.FCReportCTA
          className="report-gallery-text"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(primaryCTA),
          }}
        />
      )}
    </>
  );
};

export const FullyConnectedReportTags = memo(FullyConnectedReportTagsComp);
